import { AUTH_METHOD } from 'symbols';

export class BaseConfig {
  readonly AUTH_METHOD = AUTH_METHOD.TELEGRAM_BOT;
  LOGIN_REDIRECT_URL = '/dashboard';
}
